var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.callDurationTimer && _vm.callDurationInSec)?_c('p',{staticClass:"timer"},[_vm._v(" "+_vm._s(_vm._f("formatTimer")(_vm.callDurationInSec))+" ")]):_c('p',{staticClass:"timer"},[_vm._v(" 00:00:00 ")])}
var staticRenderFns = []

export { render, staticRenderFns }